/* InkSpire Books — theme.js */
(function () {
  "use strict";

  /* ---------- Hero Slider ---------- */
  function initHero() {
    var hero = document.querySelector("[data-hero]");
    if (!hero) return;
    var track = hero.querySelector(".hero-track");
    var slides = hero.querySelectorAll(".hero-slide");
    var dots = hero.querySelectorAll(".hero-dot");
    var prev = hero.querySelector("[data-hero-prev]");
    var next = hero.querySelector("[data-hero-next]");
    var index = 0;
    var total = slides.length;
    var timer = null;
    var interval = parseInt(hero.getAttribute("data-autoplay"), 10) || 6000;

    function go(i) {
      index = (i + total) % total;
      track.style.transform = "translateX(-" + index * 100 + "%)";
      dots.forEach(function (d, di) { d.classList.toggle("active", di === index); });
    }
    function start() { stop(); if (total > 1) timer = setInterval(function () { go(index + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); }

    if (next) next.addEventListener("click", function () { go(index + 1); start(); });
    if (prev) prev.addEventListener("click", function () { go(index - 1); start(); });
    dots.forEach(function (d, di) { d.addEventListener("click", function () { go(di); start(); }); });

    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", start);

    /* touch swipe */
    var sx = 0;
    hero.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener("touchend", function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); start(); }
    }, { passive: true });

    go(0); start();
  }

  /* ---------- Newsletter Popup ---------- */
  function initPopup() {
    var overlay = document.querySelector("[data-newsletter-popup]");
    if (!overlay) return;
    var delay = parseInt(overlay.getAttribute("data-delay"), 10) || 5000;
    var storageKey = "inkspire_news_popup_seen";

    function open() { overlay.classList.add("open"); }
    function close() {
      overlay.classList.remove("open");
      try { localStorage.setItem(storageKey, Date.now().toString()); } catch (e) {}
    }

    var seen = false;
    try {
      var ts = localStorage.getItem(storageKey);
      // re-show after 7 days
      if (ts && (Date.now() - parseInt(ts, 10)) < 7 * 864e5) seen = true;
    } catch (e) {}

    if (!seen) setTimeout(open, delay);

    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    overlay.querySelectorAll("[data-popup-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var nav = document.querySelector(".header-nav");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      var open = nav.style.display === "flex";
      nav.style.display = open ? "none" : "flex";
      nav.style.position = "absolute";
      nav.style.flexDirection = "column";
      nav.style.top = "100%"; nav.style.left = "0"; nav.style.right = "0";
      nav.style.background = "var(--ink-white)";
      nav.style.padding = "20px 24px";
      nav.style.borderBottom = "1px solid var(--ink-line)";
    });
  }

  /* ---------- App tab bar active state ---------- */
  function initTabbar() {
    var bar = document.querySelector("[data-app-tabbar]");
    if (!bar) return;
    var path = window.location.pathname;
    var tabs = bar.querySelectorAll(".app-tab");
    var match = "home";
    if (path === "/" || path === "") match = "home";
    else if (path.indexOf("/cart") === 0) match = "cart";
    else if (path.indexOf("/search") === 0) match = "search";
    else if (path.indexOf("/account") === 0) match = "account";
    else if (path.indexOf("/collections") === 0 || path.indexOf("/products") === 0) match = "shop";
    tabs.forEach(function (t) {
      if (t.getAttribute("data-tab") === match) t.classList.add("active");
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return;
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) main.src = t.getAttribute("data-full");
        thumbs.forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
      });
    });
  }

  /* ---------- Variant switching + quantity ---------- */
  function initProductForm() {
    var form = document.getElementById("product-form");
    if (!form) return;

    /* quantity stepper */
    var qtyInput = form.querySelector("[data-qty-input]");
    var minus = form.querySelector("[data-qty-minus]");
    var plus = form.querySelector("[data-qty-plus]");
    if (qtyInput) {
      if (minus) minus.addEventListener("click", function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
      if (plus) plus.addEventListener("click", function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    /* variant selection */
    var variantData = [];
    var json = document.querySelector("[data-variant-json]");
    try { variantData = JSON.parse(json.textContent); } catch (e) {}
    var optionSelects = form.querySelectorAll("[data-variant-option]");
    var idField = form.querySelector("[data-variant-id]");
    var priceEl = document.querySelector("[data-price]");

    function fmtMoney(cents) {
      return "₹" + (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    function update() {
      var chosen = [];
      optionSelects.forEach(function (s) { chosen.push(s.value); });
      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (match) {
        if (idField) idField.value = match.id;
        if (priceEl) priceEl.textContent = fmtMoney(match.price);
        var submit = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? "Add to Cart" : "Sold Out";
        }
      }
    }
    optionSelects.forEach(function (s) { s.addEventListener("change", update); });

    /* Buy Now -> go straight to checkout with this item (skips cart).
       Binds to all [data-buy-now] (incl. the sticky bar button that lives
       outside the form via form="product-form"). */
    var buyNowBtns = document.querySelectorAll("[data-buy-now]");
    buyNowBtns.forEach(function (buyNow) {
      buyNow.addEventListener("click", function (e) {
        e.preventDefault();
        var idField = form.querySelector("[data-variant-id]");
        var qtyField = form.querySelector("[data-qty-input]");
        var variantId = idField ? idField.value : null;
        var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
        if (!variantId) { form.submit(); return; }
        /* Shopify checkout permalink: /cart/{variant}:{qty} creates a
           one-item checkout and lands on the payment page directly. */
        window.location.href = "/cart/" + variantId + ":" + qty;
      });
    });
  }

  /* Product card "Buy Now" is a direct checkout permalink (<a> to /cart/{id}:1),
     so it needs no JS — it goes straight to checkout natively. */

  document.addEventListener("DOMContentLoaded", function () {
    initHero();
    initPopup();
    initMenu();
    initTabbar();
    initGallery();
    initProductForm();
  });
})();
